<!-- 个人中心 -->
<template>
  <div class="training">
    <gat-head
      class="training-head"
      @active-create="activeCreatePopup"
    ></gat-head>
    <div class="training-area">
      <div class="training-nav">
        <div class="training-area-function">
          <el-button class="add" type="primary" @click="activeCreatePopup">
            创建项目
          </el-button>
          <input
            type="text"
            class="search"
            v-model="searchKey"
            placeholder="请输入项目名称"
            @keyup.enter="GetPageListByName(1)"
          />
          <i class="ico" @click="GetPageListByName(1)"></i>
        </div>
        <!-- 导航菜单 -->
        <div class="training-tab">
          <span
            :class="['item', proOperate === 1 ? 'active' : '']"
            @click="changePageList(1)"
            >公开</span
          >
          <span
            :class="['item', proOperate != 1 ? 'active' : '']"
            @click="changePageList(0)"
            >个人</span>
        </div>
        <el-select
          v-model="editorId"
          class="edtior-select"
          placeholder="请选择编辑器类型"
          @change="changeEditorType"
          filterable
        >
          <el-option
            v-for="item in editorTypes"
            :key="item.dictId"
            :label="item.dictTypeDesc"
            :value="item.dictId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="clearfix"></div>
      <el-row>
        <project-list :project="Project" :searchKey="searchKey" @redirecTo="redirectToProject">
          <template v-slot:head="item">
            <div class="handle">
              <!-- <span :class="['handle-left', getProTypeClassName(item.project.proType)]">
                {{ item.project.proType | getProTypeName }}
              </span> -->
              <div class="right-top">
                <span
                  class="right"
                  v-if="proOperate !== 1"
                  @click.stop="changeStatus(item.project)"
                >
                  {{ item.project.proOperate == 1 ? '已公开' : '公开' }}
                  <!-- {{proOperate===1?"取消公开":item.project.proOperate==1?"已公开":"公开"}} -->
                </span>
                <span class="right" v-if="proOperate !== 1">
                  <i class="icons line"></i>
                </span>
                <span class="right" v-if="proOperate !== 1">
                  <i
                    class="icons icon_edit"
                    @click.stop="activeEditePopup(item.project)"
                  ></i>
                </span>
                <span class="right" v-if="proOperate !== 1">
                  <i class="icons line"></i>
                </span>
                <span class="right" v-if="proOperate !== 1">
                  <i
                    class="icons icon_delete"
                    @click.stop="activeDeletePopup(item.project.projectId)"
                  ></i>
                </span>
              </div>
            </div>
          </template>
          <template v-slot:content="{ project }">
            {{ project.projectContent }}
          </template>
          <template v-slot:foot="{ project }">
            <div class="record">
              <span class="bottom protype-name">
                <!-- <i class="icons el-icon-collection-tag"></i> -->
                <i :class="['icon', getEditorTypeClassName(getEditorTypeName(project.editorId))]"></i>
                <!-- {{ project.editorId | getEditorTypeName }} -->
                {{ getEditorTypeName(project.editorId) }}
              </span>
              <span class="bottom">
                <i class="icons el-icon-time"></i
                >{{ project.createTime | moment('YYYY-MM-DD') }}
              </span>
            </div>
          </template>
        </project-list>
      </el-row>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page.sync="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="slot, prev, pager, next"
          :total="totalCount"
          v-if="totalCount !== 0"
        ></el-pagination>
      </div>
    </div>
    <div class="popup-list">
      <!-- 新建项目 | 编辑项目 -->
      <gat-popup
        :class="[
          'popup-create',
          /(create|edit)/.test(popupActive) ? 'on' : 'off',
        ]"
        :title="popup.title[popupActive]"
        :primary-button="popup.btnTxt[popupActive]"
        @cancel="cancelPopup"
        @confirm="projectEdite"
      >
        <template v-slot:content>
          <el-form
            class="pop-el-form"
            :model="NewProject"
            :rules="rules"
            ref="popupUploadForm"
          >
            <el-form-item prop="projectName">
              <el-input
                placeholder="项目名称，必填项"
                v-model.trim="NewProject.projectName"
                maxlength="20"
                show-word-limit
              />
            </el-form-item>
            <el-form-item prop="proType">
              <el-select
                class="pop-select"
                v-model.trim="NewProject.proType"
                placeholder="请选择项目类型，必填项"
                filterable
              >
                <el-option
                  v-for="item in projectTypeArr"
                  :key="item.dictId"
                  :label="item.dictTypeDesc"
                  :value="item.dictId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="projectContent">
              <el-input
                class="pop-textarea"
                type="textarea"
                :rows="5"
                maxlength="200"
                placeholder="项目描述，必填项"
                v-model.trim="NewProject.projectContent"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-form>
        </template>
      </gat-popup>

      <!-- 删除 -->
      <gat-popup
        :class="['popup-delete', popupActive === 'delete' ? 'on' : 'off']"
        :title="''"
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="deleteProject"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span class="title">确定删除该项目吗？</span>
            </div>

            <div class="content">删除后可在 “回收站” 恢复哦</div>
          </div>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
// api
// import { DictType } from '@/assets/js/mixin/mixin.js'
import GatPopup from '@/components/common/GatPopup'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'
import ProjectList from '@/components/projects/ProjectList'
import PERSONAL from '@/axios/personalSpace/personalSpace.js'
import { mapGetters, mapActions } from 'vuex'
let self // 全局

export default {
  // mixins: [DictType],
  name: 'projects-list',
  components: { GatPopup, IconInfoHelp, ProjectList },

  data() {
    return {
      dictId: '',
      editorId: '',
      proOperate: 0, //0个人 1公开;
      Item: {
        img01: require('../../../public/images/img01.png'),
        img02: require('../../../public/images/img02.png'),
      },
      RunResult: {},
      isRunSuccess: false,
      Project: {
        records: [
          // {
          //   projectId: '0',
          //   projectName: 'AI 人形机器人',
          //   blocksFileUrl: '',
          //   projectContent: '',
          //   proType: '',
          //   proTypeName: '',
          //   isCollect: true,
          // },
        ],
        size: 10,
        current: 1,
        total: 0,
      },
      NewProject: {
        projectId: '0',
        projectName: '',
        projectContent: '',
        proType: '',
        proTypeName: '',
      },
      rules: {
        projectName: [{ required: true, message: '请填写项目名称' }],
        projectContent: [{ required: true, message: '请填写项目描述内容' }],
        proType: [{ required: true, message: '请选择项目类型' }],
      },
      popupActive: '',
      popup: {
        title: {
          edit: '编辑项目',
          create: '新建项目',
        },
        btnTxt: {
          edit: '确定',
          create: '新建',
        },
      },
      activeProjectId: '',
      searchKey: '',
      pageStutas: 'normal', // normal 正常获取，search 搜索状态
      isRedirectToTraining: true, // 按马上创作，进来创建完项目需要，跳转到项目实训页面
      currentPage: 1,
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
      },
      activeName: 'first',
      projectTypeArr: [],
    }
  },
  computed: {
    token() {
      return this.$store.state.token
    },
    userId() {
      return this.$store.state.accountInfo.userId
    },
    totalCount() {
      return this.Project.total ? this.Project.total : 0
    },
    editorTypes: {
      get(val) {
        let editorTypeList = [...this.editorTypeList]
        let editorTypeArr = this.editorTypeArr
        if (!this.hasLogin) {
          let list = editorTypeList.filter((item) => {
            let hasAttr = false
            editorTypeArr.some((item2) => {
              if (new RegExp(item2.menuName).test(item.dictTypeDesc)) {
                hasAttr = true
                return
              }
            })

            return hasAttr
          })
          return list
        } else {
          return this.editorTypeList
        }
      },
      set(val) {},
    },

    ...mapGetters([
      'editorTypeArr',
      'editorTypeList',
      'dictTypeList',
      'hasLogin',
      'tenantId',
    ]),
  },
  filters: {
    getProTypeName(proType) {
      let proTypeName = '其他'
      if (proType == 1) {
        proTypeName = '编程'
      } else if (proType == 2) {
        proTypeName = '硬件'
      } else if (proType == 3) {
        proTypeName = '数据'
      } else if (proType == 4) {
        proTypeName = '行业'
      }
      return proTypeName
    },
  },

  watch: {
    Project(Project) {
      this.currentPage = Project.current
    },
    'NewProject.proType'(typeId) {
      if (!typeId) {
        return
      }
      this.NewProject.proTypeName = this.getTypeName(typeId)
    },
    editorTypeList: {
      handler(val) {
        let query = this.$route.query
        if (query && query.editorId) {
          this.editorId = query.editorId
        } else if (this.editorTypes && this.editorTypes.length) {
          this.editorId = this.editorTypes[0].dictId
        }
        if (val && val.length) {
          this.GetPageList() //数据列表;
        }
      },
      deep: true,
      immediate: true,
    },
    tenantId(val) {
      this.GetPageList()
    },
  },
  beforeRouteEnter(to, from, next) {
    // 获取路由来源
    next((vm) => {
      if (to.query.operate === 'create' && from.name) vm.activeCreatePopup()
    })
  },
  beforeCreate() {
    self = this
  },
  async created() {
    this.projectTypeArr = this.$store.state.projectTypeArr // 获取行业类型
    // let query = this.$route.query
    // if (query) {
    //   this.editorId = query.editorId
    //   // this.GetPageList()
    // } else {
    //   if (this.editorTypes && this.editorTypes.length) {
    //     this.editorId = this.editorTypes[0].dictId
    //     // this.GetPageList()
    //   }
    // }
  },
  mounted() {},
  methods: {
    getProTypeClassName(proType) {
      let className = ''
      if (proType == 1) {
        className = 'programming-bg-color'
      } else if (proType == 2) {
        className = 'hardware-bg-color'
      } else if (proType == 4) {
        className = 'industry-bg-color'
      }
      return className
    },
    getEditorTypeClassName(editorType) {
      let className = ''
      if (/积木/i.test(editorType)) {
        className = 'icon_Block-Editor'
      } else if (/代码/i.test(editorType)) {
        className = 'icon_Code-Editor'
      } else if (/海龟/i.test(editorType)) {
        className = 'icon_Turtle-bank'
      } else if (/小智/i.test(editorType)) {
        className = 'icon_Little-Wisdom-Editor'
      } else if (
        editorType == '图像分类' 
        || editorType == '物体检测' 
        || editorType == '文本分类'
        || editorType == '文本标注'
        || editorType == '音频分类'
        || editorType == '音频标注'
      ) {
        className = 'icon_Data-Annotations'
      }
      return className
    },
    getEditorTypeName(editorId) {
      let editorName = ''
      this.editorTypes.forEach(item => {
        if (item.dictId === editorId) {
          editorName = item.dictTypeDesc
        }
      });
      return editorName
    },

    // 获取类型的名称
    getTypeName(typeId) {
      return this.projectTypeArr.find((item) => item.projectType === typeId)
        .dictTypeDesc
    },
    changePageList(type) {
      this.proOperate = type
      this.searchKey = ''
      this.GetPageList()
    },
    // 获取编辑器类型字典api
    // getEditorDictionaryApi() {
    //   let dictTypeCode = 'EditorType',
    //     data = {
    //       dictTypeCode,
    //     }
    //   PERSONAL.getEditorDictionary(data).then((result) => {
    //     if (result.isSuccess) {
    //       this.editorTypeDict = result.data
    //     }
    //   })
    // },
    // 获取项目分页
    GetPageList(activePageIndex) {
      var pageIndex = activePageIndex
          ? activePageIndex
          : this.Project.pageIndex
          ? this.Project.pageIndex + 1
          : 1,
        pageSize = this.Project.size ? this.Project.size : 10,
        proOperate = this.proOperate,
        userId = this.userId,
        editorId = this.editorId,
        data = {
          proOperate,
          userId,
          editorId,
          pageNum: pageIndex,
          pageSize: pageSize,
        }
      console.log('GetPageList')
      PERSONAL.getProjectListByUserId(data).then((result) => {
        if (result.isSuccess) {
          this.Project = result.data
        }
      })
    },
    //
    changeEditorType(val) {
      if (val) {
        this.dictId = val
        this.GetPageList(1)
      }
    },
    // 搜索获取项目分页
    GetPageListByName(activePageIndex) {
      var pageIndex =
          typeof activePageIndex === 'number'
            ? activePageIndex
            : this.Project.pageIndex
            ? this.Project.pageIndex + 1
            : 1,
        pageSize = this.Project.size ? this.Project.size : 10,
        projectName = this.searchKey,
        proOperate = this.proOperate,
        userId = this.userId,
        editorId = this.editorId,
        data = {
          projectName,
          proOperate,
          userId,
          pageNum: pageIndex,
          pageSize,
          editorId,
        }
      PERSONAL.getProjectListByUserId(data).then((result) => {
        if (result.isSuccess) {
          this.Project = result.data
          this.pageStutas = 'search'
        }
      })
    },
    async changeStatus(project) {
      let { proOperate, Project } = this,
        projectId = project.projectId,
        res,
        list,
        data = {
          projectId,
        }
      if (project.proOperate == 1) {
        data.proOperate = 0 //取消公开操作
      } else {
        data.proOperate = 1 //公开操作
      }

      res = await PERSONAL.openProjectByProjectId(data)
      if (res && res.isSuccess) {
        if (project.proOperate === 1) {
          list = Project.records.filter((item) => item.projectId !== projectId)
          this.Project.records = list
          this.$message.success('项目取消公开成功')
        } else {
          this.$message.success('项目公开成功')
        }
        this.GetPageListByName() //公开项目列表
      } else {
        this.$message.error(res.returnMsg)
      }
    },
    // 利用 projectId 获取项目条目
    getProjectByIdLocal(id) {
      return this.Project.records.find((item) => item.projectId === id)
    },
    getProjectIndexByIdLocal(id) {
      return this.Project.records.findIndex((item) => item.projectId === id)
    },
    // 取消弹窗
    cancelPopup() {
      if (/(create|edit)/.test(this.popupActive)) {
        this.NewProject = {
          projectId: '0',
          projectName: '',
          projectContent: '',
          proType: '',
        }
        this.$refs.popupUploadForm.resetFields()
      }

      this.popupActive = ''
    },
    // 新建项目
    activeCreatePopup() {
      this.popupActive = 'create'
      if (this.isRedirectToTraining) {
        this.isRedirectToTraining = false // 不跳转到项目实训页面
      }
    },
    // 新建项目
    createNewProject() {
      var token = this.token,
        projectName = this.NewProject.projectName,
        projectContent = this.NewProject.projectContent,
        proType = this.NewProject.proType,
        proTypeName = this.NewProject.proTypeName,
        editorId = this.editorId,
        data

      // 项目命名不能为空和超出限制的字符长度
      if (this.$util.checkStrNullOrTooLong.call(this, [projectName])) {
        return
      }

      data = {
        projectName: projectName,
        projectContent: projectContent,
        projectType: proType,
        editorId,
      }

      PERSONAL.insertProjectByUserId(data).then((result) => {
        if (result.isSuccess) {
          // 插到列表前面

          this.redirectToProject(result.data)
        } else if (result.returnMsg) {
          // 项目名称重复，重新输入名称。
          this.$message({
            message: result.returnMsg,
            type: 'error',
            duration: 2000,
          })
        }
      })
    },
    // 编辑
    activeEditePopup(data) {
      console.log(data)
      // var projectId = data.projectId;
      // var activeProject = this.getProjectByIdLocal(projectId);
      if (this.proOperate === 1) return
      this.NewProject = JSON.parse(JSON.stringify(data))
      this.popupActive = 'edit'
      // NewProject.proType
    },
    // 编辑项目
    editeProject() {
      var projectId = this.NewProject.projectId,
        projectName = this.NewProject.projectName,
        projectContent = this.NewProject.projectContent,
        proType = this.NewProject.proType,
        proTypeName = this.NewProject.proTypeName,
        blocksFileUrl = this.NewProject.blocksFileUrl,
        // activeProject = this.getProjectByIdLocal(this.activeProjectId),
        index = this.getProjectIndexByIdLocal(projectId),
        data = {}

      // 项目命名不能为空和超出限制的字符长度
      if (this.$util.checkStrNullOrTooLong.call(this, [projectName])) {
        return
      }

      data = {
        projectId: projectId,
        projectName: projectName,
        projectContent: projectContent,
        projectType: proType,
      }

      PERSONAL.updateProjectByProjectId(data).then((result) => {
        if (result.isSuccess) {
          this.Project.records.splice(
            index,
            1,
            JSON.parse(JSON.stringify(this.NewProject))
          )
          this.$message.success('成功编辑项目！')
          this.cancelPopup()
        } else if (result.errorCode === 40101) {
          // 项目名称重复，重新输入名称。
          this.$message({
            message: '项目名称重复，请重新输入名称',
            type: 'error',
            duration: 2000,
          })
        }
      })
    },
    // 编辑项目，创建项目 + 编辑项目
    projectEdite() {
      this.$refs.popupUploadForm.validate((valid) => {
        if (valid) {
          if (this.popupActive === 'create') {
            // 新增
            this.createNewProject()
          } else if (this.popupActive === 'edit') {
            // 编辑
            this.editeProject()
          }
        } else {
          this.$message.error('请将项目相关内容填写完整')
        }
      })
    },
    // 删除
    activeDeletePopup(data) {
      if (this.proOperate === 1) return
      var projectId = data
      this.popupActive = 'delete'
      this.activeProjectId = projectId
    },
    deleteProject() {
      var activeProjectId = this.activeProjectId,
        data = { projectId: activeProjectId },
        activeProjectIndex = this.getProjectIndexByIdLocal(activeProjectId)
      PERSONAL.deleteProjectByProjectId(data).then((result) => {
        // ProProject.DeleteByKey(token, activeProjectId).then(result => {
        if (result.isSuccess) {
          this.Project.records.splice(activeProjectIndex, 1)
          this.activeProjectId = ''
          this.$message.success('删除成功！')
          this.GetPageListByName()
          this.cancelPopup()
        }
      })
    },
    // 分页
    handleCurrentChange(pageIdx) {
      var pageStutas = this.pageStutas
      if (pageStutas === 'normal') {
        this.GetPageList(pageIdx)
      } else if (pageStutas === 'search') {
        this.GetPageListByName(pageIdx)
      }
    },
    // 重定向到不同类别的项目编辑器
    redirectToProject(project) {
      let editorId = this.editorId,
        dictTypeDesc
      this.editorTypes.forEach((item) => {
        if (item.dictId == editorId) {
          dictTypeDesc = item.dictTypeDesc
        }
      })
      if (/(?=.*AI-T).*(?=.积木模式)/i.test(dictTypeDesc)) {
        this.$router.push({
          name: 'ai-editor',
          query: {
            projectId: project.projectId,
            createBy: project.createBy,
            editorId,
            mode: 'code',
          },
        })
      } else if (/AI-T/i.test(dictTypeDesc)) {
        this.$router.push({
          name: 'ai-python-editor',
          query: {
            projectId: project.projectId,
            createBy: project.createBy,
            editorId,
          },
        })
      } else if (/海龟/g.test(dictTypeDesc)) {
        this.$router.push({
          name: 'baseBlock-editor',
          query: {
            projectId: project.projectId,
            createBy: project.createBy,
            editorId,
          },
        })
      } else if (/小聪/g.test(dictTypeDesc)) { 
        this.$router.push({
          name: 'hardwareBlock-editor',
          query: {
            projectId: project.projectId,
            createBy: project.createBy,
            editorId,
          },
        })
      }else if (/小智/g.test(dictTypeDesc)) { 
        this.$router.push({
          name: 'hardwareBlock-editor-B',
          query: {
            projectId: project.projectId,
            createBy: project.createBy,
            editorId,
          },
        })
      } else if (/python/g.test(dictTypeDesc)) {
        this.$router.push({
          name: 'python-editor',
          query: {
            projectId: project.projectId,
            createBy: project.createBy,
            editorId,
          },
        })
      }
    },
    handleClick(tab, event) {
    
    },
  },
}
</script>

<style lang="scss" scoped>
$head_height: 80px;
$blockly_editer_left: rgba(13, 22, 53, 0.5);
$blockly_editer_left_select: rgba(94, 147, 255, 0.1);
$bg_area_right: rgba(94, 147, 255, 0.1);
$bg_tool_button: rgba(103, 140, 255, 0.15);
$height_sidebar_item: calc(50% - 80px);

.training {
  min-height: 100%;
  // height: 100%;
  background-color: #f2f5fc;
  background-size: cover;
  background-position: center;
  color: $font_color_1st;
  padding-top: 80px;
}

.training-area {
  width: 1200px;
  padding-bottom: 50px;
  margin: 0 auto;
  .training-nav {
    height: 100px;
    width: 100%;
    border-bottom: 1px solid #d9deea;
    .edtior-select {
      margin: 61px 10px 0 0;
      float: right;
    }
  }

  .training-tab {
    float: left;
    width: 290;
    height: 50px;
    line-height: 50px;
    margin-top: 50px;

    box-sizing: border-box;
    .item {
      display: inline-block;
      width: 120px;
      height: 48px;
      margin-right: 5px;
      border: 1px solid #d9deea;
      border-bottom: none;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      color: #333;
      text-align: center;
      background: #fff;
      cursor: pointer;
    }
    .item.active {
      color: #fff;
      background: #4c88ff;
      border: 1px solid #4c88ff;
      border-bottom: none;
    }
  }
  .training-area-function {
    position: relative;
    height: 100px;
    margin-top: 1px;
    float: right;
    .ipt {
      position: relative;
      float: right;
      width: 380px;
      // height: 40px;
      // line-height: 40px;
      margin-top: 60px;
      // border: 1px solid #dfe4f1;
      border-radius: 4px;
      // background: #fff;
      // padding-left: 13px;
      font-size: 16px;
      color: #7a7c84;
      box-sizing: border-box;
      z-index: 2;
      &::-ms-clear {
        display: none;
      }
    }
    .search {
      position: relative;
      width: 420px;
      height: 40px;
      line-height: 40px;
      padding-left: 20px;
      border: 1px solid #d9deea;
      border-radius: 5px;
      box-sizing: border-box;
      // color: #a3a4a6;
      color: #7a7c84;
      background: #fff;
      top: 60px;
    }
    .ico {
      position: absolute;
      top: 70px;
      left: 390px;
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url('../../../public/images/ico23.png') no-repeat;
      cursor: pointer;
    }
    // .search {
    //   position: absolute;
    //   right: 115px;
    //   top: 70px;
    //   display: inline-block;
    //   width: 20px;
    //   height: 20px;
    //   background: url("../../../public/images/ico17.png") no-repeat;
    //   z-index: 3;
    //   cursor: pointer;
    // }
    .add {
      float: right;
      display: block;
      // width: 52px;
      // height: 52px;
      margin-top: 60px;
      margin-left: 5px;
      background-color: $bgc_btn_primary;
      // background: url("../../../public/images/ico14.png") no-repeat;
      cursor: pointer;
      z-index: 2;
      position: relative;
    }
  }
  ::v-deep.ellipsis {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .handle {
    flex: 1;
    // width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .handle-left {
      width: 43px;
      height: 20px;
      background: #ccc;
      border-radius: 10px 0px 10px 0px;
      margin-left: 6px;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      text-align: center;
    }
    .programming-bg-color {
      background: #F441F4;
    }
    .hardware-bg-color {
      background: #903CED;
    }
    .data-bg-color {
      background: #FE9922;
    }
    .industry-bg-color {
      background: #50ABEB;
    }

    .right-top {
      display: flex;
      .right {
        display: flex;
        align-items: center;
        .icon_edit,
        .icon_delete {
          display: inline-block;
          width: 18px;
          height: 18px;
          margin-right: 0 !important;
        }
        .icon_edit {
          background: url("../../assets/images/trainingCenter/icon_edit.png") no-repeat center;
          background-size: contain;
        }
        .icon_delete {
          background: url('../../assets/images/trainingCenter/icon_delete.png') no-repeat center;
          background-size: contain;
        }
      }
    }
  }

  .training-area-items {
    margin-top: 0;
    .item {
      display: flex;
      align-items: center;
      width: 100%;
      height: 90px;
      margin-bottom: 20px;
      padding: 0 20px;
      border: 1px solid #dfe4f1;
      box-sizing: border-box;
      background: #fff;
      // cursor: pointer;
      transition: all 0.2s ease;
      .icon {
        display: inline-block;
        width: 50px;
        height: 50px;
      }
      .info {
        display: flex;
        flex-direction: column;
        max-width: 75%;
        margin-left: 20px;
        margin-right: auto;
      }
      .name {
        // margin-left: 20px;
        font-size: 18px;
        color: #333;
      }
      .date {
        // margin-left: auto;
        margin-top: 10px;
        font-size: 14px;
        color: #999;
      }
      .edit {
        position: relative;
        top: 1px;
        display: inline-block;
        width: 21px;
        height: 23px;
        margin-left: 40px;
        margin-right: 14px;
        cursor: pointer;
        background: url('../../../public/images/ico15.png') no-repeat;
        z-index: 1;
      }
      .line {
        position: relative;
        top: 2px;
        display: inline-block;
        width: 1px;
        height: 24px;
        margin-right: 12px;
        background: #c0c6cc;
      }
      .delete {
        position: relative;
        float: right;
        display: block;
        width: 24px;
        height: 25px;
        cursor: pointer;
        background: url('../../../public/images/ico16.png') no-repeat;
        z-index: 1;
      }
      &:hover {
        box-shadow: 0 2px 10px 0 #e3e4e6;
        transform: translateY(-4px);
      }
    }
  }

  .record {
    display: flex;
    align-items: center;
    .protype-name {
      display: flex;
      align-items: center;
      .icon {
        width: 20px;
        height: 20px;
        border: 1px solid #ffffff;
        background: url('../../assets/images/icon_classification.png') no-repeat center;
        margin-right: 10px;
      }
      .icon_Block-Editor {
        background: url('../../assets/images/trainingCenter/icon_Block-Editor.png') no-repeat center;
        background-size: 100% 100%;
      }
      .icon_Code-Editor {
        background: url('../../assets/images/trainingCenter/icon_Code-Editor.png') no-repeat center;
        background-size: 100% 100%;
      }
      .icon_Turtle-bank {
        background: url('../../assets/images/trainingCenter/icon_Turtle-bank.png') no-repeat center;
        background-size: 100% 100%;
      }
      .icon_Little-Wisdom-Editor {
        background: url('../../assets/images/trainingCenter/icon_Little-Wisdom-Editor.png') no-repeat center;
        background-size: 100% 100%;
      }
      .icon_Data-Annotations {
        background: url('../../assets/images/trainingCenter/icon_Data-Annotations.png') no-repeat center;
        // background-size: 100% 100%;
      }
    }
  }
}
.popup-list {
  .popup {
    z-index: 3;
  }
  .popup-create,
  .popup-score,
  .popup-copy,
  .popup-rename,
  .popup-delete {
    &.off {
      display: none;
    }
  }

  .popup-delete {
    &::v-deep .popup-head {
      border-bottom: 0 none;
    }
    .popup-del-cnt {
      overflow: hidden;
      margin-top: -25px;
      .head {
        .icon-box {
          display: inline-block;
          margin-right: 12px;
          vertical-align: middle;
        }
        .title {
          display: inline-block;
          color: #333;
          vertical-align: middle;
        }
      }
      .content {
        padding: 15px 0;
        text-align: center;
        margin-top: 25px;
      }
    }
  }
  .popup-create,
  .popup-copy {
    &::v-deep .popup-inner {
      width: 480px;
      height: 400px;
    }
  }

  .pop-select {
    // margin-top: 20px;
    width: 100%;
    // &::v-deep .el-input__inner {
    //   // &::-webkit-input-placeholder {
    //   //   color: #606266;
    //   // }
    // }
  }

  .pop-textarea {
    // margin-top: 20px;
    &::v-deep .el-textarea__inner {
      font-family: sans-serif;
      resize: none;
    }
  }
  .pop-el-form {
    margin-top: 30px;
    &::v-deep {
      .el-input__count {
        line-height: 1.5;
      }
      // .el-input .el-input__count {
      //   position: relative;
      //   top: 20%;
      //   right: 0.1em;
      // }
    }
  }
}
.tabs {
  position: relative;
  &::v-deep.el-tabs--card > .el-tabs__header {
    border-bottom: 1px solid #d9deea;
    position: absolute;
    top: -65px;
    width: 100%;
    .el-tabs__nav {
      border: none;
      .el-tabs__item {
        border: 1px solid #d9deea;
        height: 50px;
        line-height: 50px;
        padding-left: 40px !important;
        padding-right: 40px !important;
        background: #fff;
        margin-right: 5px;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        font-size: 18px;
        color: #333;
        &.is-active {
          background: #4c88ff;
          color: #fff;
        }
      }
    }
  }
}
.dispermit {
  // pointer-events: none;
  opacity: 0.3;
  cursor: default;
}
</style>
